export const Divider = ({
  show = false,
  marginLeft = '1rem',
  marginRight = '.2rem',
}: {
  show?: boolean
  marginLeft?: string
  marginRight?: string
}) =>
  show ? (
    <span
      style={{
        borderLeft: '.1rem solid #ddd',
        marginLeft,
        marginRight,
      }}
    />
  ) : null
